import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type NetworkPlacement } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: NetworkPlacement.Api.InitRequest
  ): Promise<HttpApiResponse<NetworkPlacement.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/network/placement`, args),
  get: (
    apiInfo: ModuleApiInfo,
    args: NetworkPlacement.Api.GetSettingsRequest
  ): Promise<HttpApiResponse<NetworkPlacement.Api.Setting>> =>
    api.get(apiInfo, `/api/site/v1/modules/network/placement/setting`, args),
  save: (apiInfo: ModuleApiInfo, args: NetworkPlacement.Api.UpdateSettingsRequest): Promise<HttpApiResponse<void>> =>
    api.put(apiInfo, `/api/site/v1/modules/network/placement/settings`, args)
};
